/**
 * ProfilePage Component
 */

import { ProfileFragment } from '../../../../relay/profile';
import './styles.scss';

import * as React from 'react';
import * as BEM from 'react-bem-helper';
import { connect, DispatchProp } from 'react-redux';
import { createFragmentContainer } from 'react-relay';

import Page from '../../../../containers/Page';
import Button from '../../../atoms/buttons/Button';
import Thumbnail from '../../../atoms/images/Thumbnail';
import Heading from '../../../atoms/text/Heading';
import { Span } from '../../../atoms/text/Label';
import PageHeader from '../../../molecules/blocks/PageHeader';
import { baseline } from '../../../styles/grid';

// Page Path
export const ProfilePagePath = '/my/profile';

interface IOwnStateProps {
  logoutUrl: string;
}

interface IOwnProps {
  viewer: GQL.IViewer;
}

type ProfilePageProps = IOwnProps & IOwnStateProps & DispatchProp;

const classes = new BEM('profile');

interface IProfileLineInfoProps {
  isImage?: boolean;
  label: string;
  value: string | null;
}

const ProfileLineInfo = ({ isImage, label, value }: IProfileLineInfoProps) => !!value ? (
  <div {...classes('info__line')}>
    <div {...classes('info__title')}>
      <Span size="medium" textColor="bw7">{label}:</Span>
    </div>
    <div {...classes('info__data')}>
      {isImage ? (
        <Thumbnail src={value} shape="circle" size={48} withShadow={false} />
      ) : (
        <Heading is="h4" WrappedComponent="span">{value}</Heading>
      )}
    </div>
  </div>
) : null;

class ProfilePage extends React.Component<ProfilePageProps, any> {
  render() {
    const profile = this.props.viewer.profile!;
    return (
      <Page id="profile" noIndex>
        <PageHeader
          title="My Profile"
          actions={<>
            {profile.external_provider && (
              <Span
                variant="description"
                textColor="bw7"
                style={{ marginRight: baseline }}
                size="large"
              >Connected using {profile.external_provider}.
              </Span>
            )}
            <Button
              hyperLinkProps={{
                href: this.props.logoutUrl,
              }}
              wrapperComponent="a"
              label="Log out"
              variant="hyperlink"
              size="large"
            />
          </>}
        />
        <div {...classes('content-wrapper')}>
          <div {...classes('content')}>
            {profile.picture && <ProfileLineInfo label="Profile Picture" value={profile.picture} isImage />}
            <ProfileLineInfo label="Name" value={`${profile.first_name} ${profile.last_name}`} />
            <ProfileLineInfo label="Email" value={profile.email!} />
            {profile.company_name && <ProfileLineInfo label="Company" value={profile.company_name} />}
            {profile.job_type && <ProfileLineInfo label="Role/Position" value={profile.job_type.name} />}
            {profile.industry && <ProfileLineInfo label="Industry" value={profile.industry.name} />}
          </div>
        </div>
      </Page>
    );
  }
}

const ConnectedProfilePage = connect<IOwnStateProps, {}, IOwnProps, IStoreState>(
  ({ authentication }) => ({
    logoutUrl: authentication.logoutUrl,
  }),
)(ProfilePage);

const RelayProfilePage = createFragmentContainer(
  ConnectedProfilePage,
  ProfileFragment,
);

export default RelayProfilePage;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/public/components/pages/account/Profile/index.tsx